import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {Board} from '../../../modele/boardModel';
import {EndpointService} from "../../../services/endpoint/endpoint.service";
import {DummydataService} from '../../../services/dummydata/dummydata.service';
import {Tile} from '../../../modele/dummyModel';
import {User, Owner} from '../../../modele/user/userModel';
import {UserSettings} from "../../../modele/user/userSettings";
import {interval, Subscription} from 'rxjs';
import {ShowhideService} from '../../../services/showhide/showhide.service';
import {UserService} from "../../../services/user.service";
import {NGXLogger} from "ngx-logger";
import {RelationService} from "../../../services/relation/relation.service";
import {MessagesService} from "../../../services/messages/messages.service";



@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    isUserLoggedIn: boolean;
    tilesDashboard: Tile[] = [];
    tilesNonLoggedInn: Tile[] = [];
    local_newfollow_count: number = 0;
    local_newComment_count: number = 0;
    getCurrentUserLiveRequest: User = new User();
    user_name: string;
    subscription: Subscription;
    log_prefix:string = this.constructor.name + ":";
    local_newUserRelation_count: number = 0;
    local_newMsg_count: number = 0;



    constructor(private endpointSrv: EndpointService,
                private dummydata: DummydataService,
                private nav: ShowhideService,
                private userService: UserService,
                private logger: NGXLogger,
                private relationService: RelationService,
                private msgSrv: MessagesService,

    ) {
        this.gettileaboutwhooosh();
        this.gettilenotLoggedInn();

        this.userService.getUserExistsInServiceSubject().subscribe(haveUserSessionInService =>{
            this.logger.info(this.log_prefix,"got informed of new state:",haveUserSessionInService );
            this.isUserLoggedIn = haveUserSessionInService;
            if(this.isUserLoggedIn === true){
                const source = interval(15000);
                this.subscription = source.subscribe(val => this.callNotifications());
            } else {
                this.getCurrentUserLiveRequest = new User();
                if(this.subscription != null){
                    this.logger.info(this.log_prefix,"unsubscribing event loop");
                    this.subscription.unsubscribe();
                }
            }
        });
        this.userService.getUserSubject().subscribe(user => {
            this.logger.info(this.log_prefix,"got informed of user:",user.user_id);
            this.getCurrentUserLiveRequest = user;
            this.getData(user.user_id);
            this.user_name = user.user_name;
            this.isUserLoggedIn = true;
        });
    }

    callNotifications() {

        this.logger.info(this.log_prefix,"checking notifications for current user");
        if (this.getCurrentUserLiveRequest['user_id'] != null && this.getCurrentUserLiveRequest['user_id'] != -1) {
            this.getData(this.getCurrentUserLiveRequest['user_id']);
        }
    }

    gettileaboutwhooosh(): void {
        this.tilesDashboard = this.dummydata.getTiles();
    }

    gettilenotLoggedInn(): void {
        this.tilesNonLoggedInn = this.dummydata.getTilesNotLoggedIn();
    }

    ngOnInit(): void {
    }

    getData(user_id) {
        this.endpointSrv.getBackendnewFollowerCountForUser(user_id).subscribe(boardhits => {
            let newFollowerForUser = boardhits['number_of_unread_follower'];
            this.local_newfollow_count = newFollowerForUser
        });
        // this.endpointSrv.getFollowerUnreadCountEmitter().subscribe(count => {
        //     this.local_newfollow_count = count;
        // });
        this.endpointSrv.getNewCommentUnreadCount().subscribe(boardhits => {
            let newFollowerForUser = boardhits['number_of_comments_unread'];
            this.local_newComment_count = newFollowerForUser
        });
        this.endpointSrv.getCommentUnreadCountEmitter().subscribe(count => {
            this.local_newComment_count = count;
        });
        this.relationService.getRelationUnreadCountRequest().subscribe(data=>{
            this.local_newUserRelation_count = data['number_of_relation_request_unread']
        })
        this.msgSrv.getMessageCount().subscribe(data=>{
            this.local_newMsg_count = data['number_of_user_message']
            this.logger.info("hierr der msg Count", this.local_newMsg_count )

        })
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
